<template>
    <v-data-table
      :headers="headers"
      :items="listadoGarantias">
      <template
        v-slot:[`item.fechaInicio`]="{ item }">
        {{ item.fechaInicio ? new Date(`${item.fechaInicio} 00:00:0`).toLocaleDateString() : '' }}
      </template>
      <template
        v-slot:[`item.fechaTermino`]="{ item }">
        {{ new Date(`${item.fechaTermino} 00:00:0`).toLocaleDateString() }}
      </template>
      <template
        v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano
          :fecha="item.createdAt">
        </fecha-humano>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
      v-if="mixValidaScopesActions(2)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
      v-if="mixValidaScopesActions(3)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
    </v-data-table>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoGarantias',
  props: {
    listadoGarantias: {
      type: Array,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Concepto',
          align: 'start',
          sortable: false,
          value: 'concepto',
        },
        { text: 'Fecha de Inicio', value: 'fechaInicio' },
        { text: 'Fecha de Termino', value: 'fechaTermino' },
        { text: 'Comentarios', value: 'comentarios' },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    editar(garantiaContrato) {
      eventBus.$emit('editar-garantia-contrato', garantiaContrato);
    },
    borrar(garantiaContrato) {
      eventBus.$emit('eliminar-garantia-contrato', garantiaContrato);
    },
  },
};
</script>

<style lang="scss">

</style>
